import React, { createContext, useState, useContext } from "react";
import PropTypes from "prop-types";
import useLogger from "../util/Logger";

const BreadcrumbContext = createContext();

export default function BreadcrumbProvider({ children }) {
  const logger = useLogger();

  const [breadcrumbHash, setBreadcrumbHash] = useState(0);
  const [breadcrumb, setBreadCrumbState] = useState([]);

  const setBreadcrumb = (breadcrumbData) => {
    logger.debug(
      "BreadcrumbProvider.setBreadcrumb",
      `Calculating new breadcrumb hash`
    );
    const newHash = JSON.stringify(breadcrumbData);
    logger.debug(
      "BreadcrumbProvider.setBreadcrumb",
      `Old breadcrumb hash '${breadcrumbHash}', New breadcrumb hash '${newHash}'`
    );
    if (newHash !== breadcrumbHash) {
      logger.debug("BreadcrumbProvider.setBreadcrumb", `Updating breadcrumb`);
      setBreadcrumbHash(JSON.stringify(breadcrumbData));
      setBreadCrumbState(breadcrumbData);
    }
  };

  const getBreadcrumb = () => breadcrumb;

  return (
    <BreadcrumbContext.Provider
      value={{
        setBreadcrumb,
        getBreadcrumb,
      }}
    >
      {children}
    </BreadcrumbContext.Provider>
  );
}

BreadcrumbProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useBreadcrumb = () => useContext(BreadcrumbContext);
